<div 
    class="app-avatar {{joinedClasses()}}"
    [class.app-avatar--placeholder]="!image() && !initials() && !computedInitials()"
    [style.width]="size + 'px'"
    [style.height]="size + 'px'"
    [style.font-size]="fontSize + 'px'"
    [style.background-color]="backgroundColor()"
    [style.color]="color()"
    [style.border-color]="borderColor()"
    [style.border-width]="borderWidthComputed() + 'px'"
    >
    @if(!image()){ <span>{{initials() ?? computedInitials()}}</span> }
    @if(image()){ <img [src]="image()" [alt]="initials() ?? computedInitials()"> }
</div>